import { api } from '../../libs/api'
import { ErrorMessages } from '../../constants'

export default {
  namespaced: true,

  state: {
    authenticated: false,
    forceSignOuted: false,
    signIn: {
      errors: [],
    },
    signOut: {
      errors: [],
      logouting: false,
    },
  },
  getters: {
    logouting: state => state.signOut.logouting,
    authenticated: state => state.authenticated,
  },
  mutations: {
    authenticated: state => state.authenticated = true,
    unAuthenticated: state => state.authenticated = false,
    forceSignOuted: (state, value) => state.forceSignOuted = value,
    signInErrors: (state, errors) => state.signIn.errors = errors,
    signOutErrors: (state, errors) => state.signOut.errors = errors,
    logouting: (state, logouting) => state.signOut.logouting = logouting,
  },
  actions: {
    async prepare ({ commit, state: { forceSignOuted } }) {
      if (!forceSignOuted) {
        commit('signInErrors', [])
      }
      commit('forceSignOuted', false)
    },
    async signIn ({ dispatch, commit }, { email, password, sessionKeeping }) {
      let result = {}
      try {
        result = await api.signIn({ email, password, sessionKeeping })
        await dispatch('user/set', { user: result.results[0] }, { root: true })
        await dispatch('master/fetch', {}, { root: true })
      } catch (e) {
        commit('signInErrors', e)
        return Promise.reject(e)
      }

      commit('signInErrors', [])
      commit('authenticated')
      return Promise.resolve()
    },
    async signOut ({ commit }) {
      try {
        commit('logouting', true)
        await api.signOut()
        commit('user/clear', {}, { root: true })
        commit('jobTableConfiguration/clear', {}, { root: true })
        commit('companyTableConfiguration/clear', {}, { root: true })
        commit('corporationTableConfiguration/clear', {}, { root: true })
      } catch (e) {
        commit('signOutErrors', e)
        commit('logouting', false)
        return Promise.reject(e)
      }

      commit('signOutErrors', [])
      commit('logouting', false)
      commit('unAuthenticated')
    },
    async forceSignOut ({ commit, state: { authenticated } }) {
      if (authenticated) {
        await commit('forceSignOuted', true)
        commit('signInErrors', [{ type: 'system', message: '他の端末でログインされたか、セッションタイムアウトとなりました。再度ログインしてください。' }])
      } else {
        commit('signInErrors', [])
      }
      commit('signOutErrors', [])
      commit('logouting', false)
      commit('unAuthenticated')
    },
    async checkAuthorization ({ state: { authenticated } }) {
      if (authenticated) {
        return Promise.resolve()
      }
      throw new Error(ErrorMessages.NO_AUTHORIZATION)
    },
    async filterSignedInUser ({ state: { authenticated } }) {
      if (authenticated) {
        throw new Error(ErrorMessages.NO_SIGNIN)
      }
      return Promise.resolve()
    },
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/session.js